import React, { useMemo, useState } from 'react';
import { find, findIndex, isInteger, isNumber, map, sum } from 'lodash';
import { isNumeric, parseDecimal } from '../../../util/utils';

const QuoteDiscCalcMobile = ({ original, ...props }) => {
  const originalValue = React.useMemo(() => {
    return Number(parseFloat(original.value).toFixed(2));
  }, [original.value]);

  const updatedValue = React.useMemo(() => {
    return original.calcDiscount;
  }, [original.calcDiscount]);

  const [value, setValue] = React.useState(
    isNumber(updatedValue)
      ? parseFloat(updatedValue).toFixed(2)
      : isNumber(originalValue)
        ? parseFloat(originalValue).toFixed(2)
        : '0.00',
  );

  React.useEffect(() => {
    setValue(parseFloat(updatedValue).toFixed(2));
  }, [updatedValue]);

  const handleChange = React.useCallback((e) => {
    e.preventDefault();
    const _value = e.target.value;
    if (isNumeric(_value)) setValue(_value);
  }, []);

  const handleBlur = React.useCallback((e) => {
    e.preventDefault();
    const _value = e.target.value;
    isNumeric(_value, true) ? props.handleQuoteBlur(_value, original) : props.handleQuoteBlur(0, original);
  }, []);
  //const sign = Number(value) === 0 ||  !value ? '' : Number(value) > 0 ? '-' : '+';
  const sign = Number(value) > 0 ? '+' : '';
  // if (original.isFcCol) {
  //   return '-';
  // }
  return (
    <div className="tableInput">
      {(!props.hours && !original.isFcCol) ? (
        <>
          <span className="add-sign-mobile">{sign}</span>
          <input
            style={{ paddingLeft: Number(value) > 0 ? 8 : 2 }}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </>
      ) : (
        props.hours ?
          <input
            style={{ paddingLeft: Number(original?.hours) > 0 ? 8 : 2 }}
            value={original?.hours}
          />
          :
          '-'
      )}
    </div>
  );
};

export default QuoteDiscCalcMobile;
